import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=76135dfb&scoped=true&"
import script from "./AvatarMenu.vue?vue&type=script&lang=js&"
export * from "./AvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=76135dfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76135dfb",
  null
  
)

export default component.exports